// extracted by mini-css-extract-plugin
export default {"links":"Navigation_links__fL6Qd","linkActive":"Navigation_linkActive__d7+ds"};